module.exports = __webpack_public_path__ + "img/avatar6.4c2c881b.png";